import { render, staticRenderFns } from "./SuccessfulSubmit.vue?vue&type=template&id=7f1a1a76&scoped=true"
import script from "./SuccessfulSubmit.vue?vue&type=script&lang=ts"
export * from "./SuccessfulSubmit.vue?vue&type=script&lang=ts"
import style0 from "./SuccessfulSubmit.vue?vue&type=style&index=0&id=7f1a1a76&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f1a1a76",
  null
  
)

export default component.exports